import React from 'react';
import { connect } from 'react-redux';
import makeForm from '../makeForm';
import { declaredValueCleaveOptions, url } from '../../../../config';
import { hasNumber } from '../../../../utils';
import { choices } from '../../../../choices';
import ContinueButton from '../ContinueButton';
import Form from '../../Common/Form';
import FormGroup from '../../Common/FormGroup';
import InputCurrency from '../../Common/InputCurrency';
import RadioGroup from '../../Common/RadioGroup';
import loadable from '@loadable/component';
const AddressAutoComplete = loadable(() => import('../../Common/AddressAutoComplete'))
import yup from 'yup';
import GoBackButton from '../../Common/GoBackButton';
import s from '../../Common/GoBackButton.scss';
import sc from '../ChatsForm.scss';


const propertyType = {
    BU: true,
    BO: true,
    RE: true,
    RO: true,
    BC: false,
}

const CollateralForm = ({
    apptype,
    values,
    handleChange,
    handleCleaveChange,
    destination,
    errors,
    withCoborrower,
    exchange,
    with_collateral,
    onSubmit,
    is_staff,
}) => {
    return(
        <div>
            <div className={sc.formContainer}>
                <div className={s.goBack}><GoBackButton children={'Volver'} link={url('cotitulares', apptype)}/></div>
                <h3 className="chat-title">Datos de la propiedad</h3>
                <Form onSubmit={onSubmit}>
                    <FormGroup label={`¿Cuál es el valor estimado de la propiedad que va${withCoborrower ? 'n' : 's'} a ${apptype === 'sp' ? 'comprar' : 'ceder en garantía'}? `}>
                        <InputCurrency
                            cleaveOptions={declaredValueCleaveOptions}
                            placeholder='Ej 100.000'
                            currency={values.collateral_currency}
                            value={values.collateral_value || ''}
                            name="collateral"
                            onValueChange={handleCleaveChange}
                            onCurrencyChange={handleChange}
                            exchange={exchange}
                            addOn={'USD'}
                            validator={yup.number().typeError('').min(values.collateral_currency === 'USD' ? 50000 : 2500000, `El valor de propiedad no puede ser menor a USD 50.000`).max(values.collateral_currency === 'USD' ? 2000000 : 80000000, '¡Ups! El valor ingresado de la propiedad es muy alto. Revisá si está ingresado correctamente.')}
                            errors={errors.collateral_value}
                        />
                    </FormGroup>
                    <RadioGroup
                        label="¿En qué zona está la propiedad?"
                        name="zone"
                        errors={errors.zone}
                        onChange={handleChange}
                        selected={values.zone}
                    >
                        {choices.zonesHome.map(({ text, value }) => [text, value])}
                    </RadioGroup>
                    {is_staff &&
                        <div>
                            <RadioGroup
                                label="¿Es vivienda única?"
                                onChange={handleChange}
                                name="unique_home"
                                selected={values.unique_home}
                                errors={errors.unique_home}
                            >
                                {[
                                    ['Si', true],
                                    ['No', false],
                                ]}
                            </RadioGroup>
                            {apptype === 'hd' &&
                                <RadioGroup
                                    label="¿A nombre de quién está la propiedad?"
                                    onChange={handleChange}
                                    name="owner"
                                    selected={values.owner}
                                    errors={errors.owner}
                                >
                                    {choices.owner.map(({ text, value }) => [text, value])}
                                </RadioGroup>
                            }
                            <RadioGroup
                                label="¿La Propiedad tiene título inscripto?"
                                onChange={handleChange}
                                name="inscribed_title"
                                selected={values.inscribed_title}
                                errors={errors.inscribed_title}
                            >
                                {[
                                    ['-', null],
                                    ['Si', true],
                                    ['No', false],
                                ]}
                            </RadioGroup>
                        </div>
                    }
                    {apptype === 'hd' &&
                        <FormGroup
                            label={`¿Cuál es la dirección exacta?`}
                        >
                            <AddressAutoComplete value={values.address} onChange={handleChange} name="address" errors={errors.address || (values.address) ? (hasNumber(values.address)) ? '' : '¡Ups! Te faltó ingresar la altura.' : ''} />
                        </FormGroup>
                    }
                    <ContinueButton autoFocus={false} sticky={true} disabled={(values.collateral_value && values.zone && values.address && hasNumber(values.address)) ? false : true}/>
                </Form>
            </div>
        </div>
    );
}
const mapStateToProps = ({ user }) => ({ is_staff: !!user.is_staff })

export default connect(mapStateToProps)(makeForm(CollateralForm));
